export const LANGS = {
  python: [0, "text/x-python"],
  javascript: [1, "text/javascript"],
  go: [2, "text/x-go"],
  python3: [3, "text/x-python3"],
  perl: [4, "text/x-perl"]
};

export const Codes = {
  python: 'print "Hello Python!"',
  javascript:
    '//Not happy with Plain JS? Use JS/HTML/CSS option for using your own libraries.\n\nconsole.log("Hello JS!");',
  go:
    'package main\nimport "fmt"\n\nfunc main(){\n  \n\tfmt.Printf("Hello Go")\n}',
  python3: 'print("Hello Python3")',
  perl: "use strict;\nuse warnings\n;use v5.14; say 'Hello Perl!';"
};
